export default class ProductTypes extends HTMLElement {

	constructor(){

		super();

		this.swap = true;
		this.products = this.querySelectorAll("[data-product-id]");
		this.section = document.getElementById(`shopify-section-${this.dataset.section}`);

		if(this.swap){
			this.products.forEach(el => this.bindSwap(el));
		}
	}

	/** Asset swap */
	bindSwap(el){

		el.addEventListener("click", this.swapEvent.bind(this), false);
	}

	swapEvent(event){

		event.preventDefault();

		/** Hero Swap */
		let clickEl = event.target.closest("a");
		let url = clickEl.href;

		fetch(`${url}?section_id=${this.dataset.section}`)
			.then((response) => response.text())
			.then((responseText) => {

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const productHero = html.getElementById(`shopify-section-${this.dataset.section}`);

				this.section.innerHTML = productHero.innerHTML;

				/** Update window URL */
				this.updateUrl(url);

				/** Refresh images */
				window.Zero.lazyLoad.update();
			});
	}

	updateUrl(url){
		window.history.replaceState({}, "", `${url}`);
	}
}